export class ExportingTypesEnum {
  static PNG = "png";
  static XLSX = "xlsx";
  static CSV = "csv";
}

export const exportingTypes = [
  {
    label: '.png (fundo transparente)',
    value: ExportingTypesEnum.PNG,
  },
  {
    label: '.xlsx (Microsoft Excel)',
    value: ExportingTypesEnum.XLSX,
  },
  {
    label: '.csv (valores separados por vírgulas)',
    value: ExportingTypesEnum.CSV,
  },
];
